import api from 'api';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import Stepper from './Stepper';
import * as S from '../../../Dropdowns.styled';
import { useTranslation } from 'react-i18next';

type VisaStatusDropdownProps = {
    open: boolean;
    handleOpenCloseVisaStatusDropdown: () => void;
};

const VisaStatusDropdown = ({
    open,
    handleOpenCloseVisaStatusDropdown,
}: VisaStatusDropdownProps) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const { entity: activeApp } = useSelector((state: RootState) => state.application);
    const [assessmentAgreementSigned, setAssessmentAgreementSigned] = useState<boolean>(false);

    useEffect(() => {
        const fetchIsAssessmentAgreementSignedData = async () => {
            try {
                const response =
                    await api.assessmentAgreement.getAssessmentAgreementStatusForUser();
                response.data.candidate_signed_date
                    ? setAssessmentAgreementSigned(true)
                    : setAssessmentAgreementSigned(false);
            } catch (e) {
                console.error(e);
            }
        };

        fetchIsAssessmentAgreementSignedData();
    }, []);

    return (
        <>
            <S.Dropdown onClick={() => handleOpenCloseVisaStatusDropdown()}>
                {t('visaStatus', { lng: language })}
                <S.DropdownIcon style={{ width: '17px', transform: open ? 'scaleY(-1)' : '' }} />
            </S.Dropdown>

            {activeApp && (
                <Stepper
                    open={open}
                    assessmentAgreementSigned={assessmentAgreementSigned}
                    visaOfferSent={activeApp.date_offer_sent !== null}
                    visaAgreementSigned={activeApp.date_agreement_signed !== null}
                    dateFullyPaid={activeApp.date_fully_paid !== null}
                    consultantName={activeApp.consultant_name ? activeApp.consultant_name : ''}
                    status={activeApp.client_status}
                />
            )}
            {!activeApp && (
                <Stepper
                    open={open}
                    assessmentAgreementSigned={false}
                    visaOfferSent={false}
                    visaAgreementSigned={false}
                    dateFullyPaid={false}
                    consultantName={''}
                    status={null}
                />
            )}
        </>
    );
};

export default VisaStatusDropdown;
